/**
 * 月次経費精算（立替経費）の精算額。社外の経費精算 SaaS が月次締め後に出力した
 * 人ごと・月ごとの明細を外部取込で持つもので、DRESS CODE 側に一次データは無い。
 * したがって本テーブルはサンプル値（架空の従業員）。
 *
 * 法令が定める料額表・税額表ではなく自社の経費規程に沿った運用データなので、
 * 法定基準一覧ではなく参照先カタログに `coreSource: 'in-house'` として載る。
 */

import type { PayrollReferenceCatalogTable } from '../../types';

/**
 * 月次経費精算 精算額表サンプル。社員 × 対象年月をキーに立替経費の精算額を引く。
 *
 * 値の整合で守っていること:
 * - 精算合計額 = 交通費 + 出張旅費 + 接待交際費 + 図書研修費 + 備品消耗品費 + その他。
 * - 課税対象額 + 非課税額 = 精算合計額。
 * - 課税対象額は「その他」欄の渡切交際費の額と一致する。実費弁償の立替精算は原則非課税で、
 *   精算を求めない定額支給（渡切交際費）だけが給与として課税対象になるため。
 *   渡切交際費が無い行は課税対象額 0 円になる。
 * - 対象年月は 2026-07 の単月に揃えてある（2026 年 8 月支給の給与に載せる想定）。
 * - 「交通費」は業務上の移動にかかった実費で、通勤定期代（参照先カタログの R008）は含まない。
 * - 行は参照先カタログのコア DB 抽出 3 表・法定基準一覧の「労働者別 住民税額」と同じ 10 名・同じ並び
 *   （社員番号で突合したときに別人の額が混ざらないようにするため）。
 */
export const monthlyExpenseReimbursementTable: PayrollReferenceCatalogTable = {
  columns: [{
    label: '社員番号'
  }, {
    label: '氏名'
  }, {
    label: '対象年月'
  }, {
    align: 'end',
    label: '交通費（円）'
  }, {
    align: 'end',
    label: '出張旅費（円）'
  }, {
    align: 'end',
    label: '接待交際費（円）'
  }, {
    align: 'end',
    label: '図書研修費（円）'
  }, {
    align: 'end',
    label: '備品消耗品費（円）'
  }, {
    align: 'end',
    label: 'その他（円）'
  }, {
    align: 'end',
    label: '精算合計額（円）'
  }, {
    align: 'end',
    label: '課税対象額（円）'
  }, {
    align: 'end',
    label: '非課税額（円）'
  }, {
    align: 'end',
    label: '申請件数（件）'
  }, {
    label: '承認日'
  }],
  rows: [['EMP-1001', '田村 拓真', '2026-07', '12,480', '38,600', '0', '5,800', '3,200', '0', '60,080', '0', '60,080', '7', '2026-08-05'], ['EMP-1002', '岡部 美咲', '2026-07', '6,320', '0', '0', '2,400', '1,100', '0', '9,820', '0', '9,820', '3', '2026-08-05'], ['EMP-1003', '川島 隆之', '2026-07', '18,750', '62,400', '48,000', '0', '2,600', '30,000', '161,750', '30,000', '131,750', '12', '2026-08-06'], ['EMP-1004', '大久保 稔', '2026-07', '4,180', '0', '0', '0', '900', '0', '5,080', '0', '5,080', '2', '2026-08-05'], ['EMP-1005', '藤原 里美', '2026-07', '21,340', '85,200', '96,500', '12,000', '4,300', '50,000', '269,340', '50,000', '219,340', '15', '2026-08-06'], ['EMP-1006', '小柳 亮介', '2026-07', '9,860', '24,300', '0', '8,500', '1,800', '0', '44,460', '0', '44,460', '6', '2026-08-05'], ['EMP-1007', '中原 千夏', '2026-07', '7,540', '12,800', '15,200', '0', '2,100', '0', '37,640', '0', '37,640', '5', '2026-08-05'], ['EMP-1008', '望月 康平', '2026-07', '11,260', '45,900', '22,000', '3,600', '2,400', '0', '85,160', '0', '85,160', '9', '2026-08-06'], ['EMP-1009', '石垣 芽衣', '2026-07', '5,480', '0', '0', '1,900', '700', '0', '8,080', '0', '8,080', '3', '2026-08-05'], ['EMP-1010', '篠原 正和', '2026-07', '10,920', '31,500', '8,000', '0', '1,500', '20,000', '71,920', '20,000', '51,920', '8', '2026-08-06']]
};